export default "__VITE_ASSET__THGHo8jG__"